import { Controller } from "@hotwired/stimulus";

// Accept / Decline / Request changes on an instructor's shift request.
// Accept reveals the pre-filled flexible shift form; the other two reveal a
// note for the instructor and submit it.
export default class extends Controller {
  static targets = [
    "choice",
    "flexibleForm",
    "noteForm",
    "statusInput",
    "noteLabel",
    "noteInput",
    "submitButton",
  ];

  accept(event) {
    this.highlight(event.currentTarget);
    this.noteFormTarget.classList.add("u-hidden");
    this.flexibleFormTarget.classList.remove("u-hidden");
    this.flexibleFormTarget.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  decline(event) {
    this.showNote(event.currentTarget, {
      status: "declined",
      label: "Reason for declining (optional)",
      button: "Decline",
      required: false,
    });
  }

  requestChanges(event) {
    this.showNote(event.currentTarget, {
      status: "changes_requested",
      label: "What should the instructor change?",
      button: "Request changes",
      required: true,
    });
  }

  showNote(button, { status, label, button: buttonLabel, required }) {
    this.highlight(button);
    this.flexibleFormTarget.classList.add("u-hidden");
    this.noteFormTarget.classList.remove("u-hidden");
    this.statusInputTarget.value = status;
    this.noteLabelTarget.textContent = label;
    this.submitButtonTarget.textContent = buttonLabel;
    this.noteInputTarget.required = required;
    this.noteInputTarget.focus();
  }

  highlight(selected) {
    this.choiceTargets.forEach((choice) => {
      choice.classList.toggle("Button--outline", choice !== selected);
    });
  }
}
